import React from 'react'
import { TableProps } from 'antd/lib/table'

import { Table, Text } from 'src/components/Ant'
import { ColumnProps } from 'src/components/Ant/Table'
import { Report } from 'src/store/ducks/reports/types'

function TableList({ ...props }: TableProps<Report>) {
  const columns: ColumnProps<Report>[] = [
    {
      align: 'right',
      dataIndex: 'report_data_id',
      key: 'report_data_id',
      render: (value: string) => <Text>{value}</Text>,
      title: 'web.reports.table.id'
    },
    {
      dataIndex: 'name',
      key: 'name',
      render: (value: string) => <Text>{value}</Text>,
      title: 'web.reports.table.name'
    },
    {
      dataIndex: 'description',
      key: 'description',
      render: (value: string) => <Text>{value}</Text>,
      title: 'web.reports.table.description'
    }
  ]
  return <Table {...props} className="table-striped" columns={columns} />
}

export default TableList
